import { Box, Stack, Typography, SxProps } from "@mui/material";
import { FC } from "react";

type ItemProps = {
  label: string;
  value: number | string | null | undefined;
  display?: { xs: string; md: string };
  sx?: SxProps;
};
export const Item: FC<ItemProps> = ({ label, value, sx }) => {
  return (
    <Box sx={sx}>
      <Stack
        direction={{ xs: "row", md: "column" }}
        justifyContent={{ xs: "space-between", md: "flex-start" }}
      >
        <Typography variant="body1" fontWeight={600}>
          {label}
        </Typography>
        <Typography variant="body1">{value ?? "N/A"}</Typography>
      </Stack>
    </Box>
  );
};
